import React from 'react';
import { ReactComponent as UpArrow } from 'Icons/upPolygon.svg';
import { ReactComponent as DownArrow } from 'Icons/downPolygon.svg';
import DropButton from './DropButton';

function DropUpDown({
  val,
  onUpClick,
  onDownClick,
  upDisabled = false,
  downDisabled = false,
}) {
  return (
    <div
      id="controls-dropupdown-wrapper"
      data-testid="controls-dropupdown-wrapper"
      style={{ border: '1px solid #4D4D4D', width: '100%', height: '100%' }}
      className="flex"
    >
      <div
        id="controls-dropupdown-value"
        data-testid="controls-dropupdown-value"
        style={{ flex: 1 }}
        className="flex flex-xy-center"
      >
        {val}
      </div>

      <div
        id="controls-dropupdown-buttons-wrapper"
        data-testid="controls-dropupdown-buttons-wrapper"
        className="flex flex-column"
        style={{ flex: 1 }}
      >
        <DropButton onClick={onUpClick} disabled={upDisabled}>
          <UpArrow
            id="controls-dropupdown-icon-up"
            data-testid="controls-dropupdown-icon-up"
            style={{ height: '50%' }}
            className={`${upDisabled ? 'grey-svg' : ''}`}
          />
        </DropButton>
        <DropButton onClick={onDownClick} disabled={downDisabled}>
          <DownArrow
            id="controls-dropupdown-icon-down"
            data-testid="controls-dropupdown-icon-down"
            style={{ height: '50%' }}
          />
        </DropButton>
      </div>
    </div>
  );
}

export default DropUpDown;
